export const LEGAL_COMMUNITY_ENGAGEMENT: string = `

### <!--= ++sectionIndex -->. Community-Engagement
<!-- subSectionIndex = 0; -->

<!-- if (engagement.community.discord) { -->
#### <!--= sectionIndex -->.<!--= ++subSectionIndex -->. Discord

Wir nutzen die soziale Plattform Discord, um das Engagement und die Diskussion in der Community zu erleichtern. Discord ist eine Instant-Messaging- und digitale Vertriebsplattform, die von Discord Inc., 3155 South Bascom Avenue, Campbell, California 95008, USA, betrieben wird.

Wenn Sie sich für die Teilnahme an unserer Community auf Discord entscheiden, beachten Sie bitte, dass Sie den Nutzungsbedingungen und Datenschutzrichtlinien von Discord zustimmen müssen. Discord erhebt und verarbeitet Benutzerdaten, einschließlich, aber nicht beschränkt auf Benutzername, E-Mail-Adresse, IP-Adresse und Geräteinformationen, wie in seiner Datenschutzrichtlinie beschrieben.

Die Teilnahme an unserer Discord-Community ist völlig optional. Bitte beachten Sie, dass Discord eine externe Plattform ist und wir daher keine Kontrolle oder Verantwortung dafür haben, wie Discord mit Ihren Daten umgeht.

Nähere Informationen zum Umgang mit Nutzerdaten finden Sie in der Datenschutzerklärung von Discord, abrufbar unter [Discord-Datenschutzerklärung,](https://discord.com/privacy).
<!-- } -->

<!-- if (engagement.community.facebook) { -->
#### <!--= sectionIndex -->.<!--= ++subSectionIndex -->. Facebook

Wir nutzen die soziale Netzwerkplattform Facebook, um unsere Online-Community aufzubauen und mit ihr in Kontakt zu treten. Facebook ist ein Dienst der Facebook Inc., 1 Hacker Way, Menlo Park, California 94025, USA.

Wenn Sie sich dafür entscheiden, unserer Facebook-Community beizutreten und daran teilzunehmen, beachten Sie bitte, dass Sie den Nutzungsbedingungen und Datenschutzrichtlinien von Facebook unterliegen. Facebook erhebt, speichert und verarbeitet personenbezogene Daten der Nutzer im Rahmen seiner eigenen Datenverwendungsrichtlinie.

Die Teilnahme an unserer Facebook-Community ist völlig freiwillig. Bitte beachten Sie, dass Facebook keine Kontrolle darüber und keine Verantwortung dafür hat, wie Facebook mit Ihren Daten umgeht, da es sich bei Facebook um eine externe Plattform handelt.

Nähere Informationen zum Umgang mit Nutzerdaten durch Facebook finden Sie in der Datenrichtlinie von Facebook, abrufbar unter [Facebook-Datenrichtlinie](https://www.facebook.com/about/privacy/).
<!-- } -->
`;
